import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './main/_components/page-not-found/page-not-found.component';
import { DashboardComponent } from './main/_components/dashboard/dashboard.component';
import { LoginComponent } from './main/_components/login/login.component';
import { LogoutComponent } from './main/_components/logout/logout.component';
import { AuthGuard } from './main/_guards/auth.guard';
import { RegisterComponent } from './main/_components/register/register.component';
import { ActivateComponent } from './main/_components/activate/activate.component';
import { TestSchedulerComponent } from './test-scheduler/test-scheduler.component';

const routes: Routes = [

	// lazy loads
	{
		path: 'services', loadChildren: './services/services.module#ServicesModule', canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: false
		}
	},
	{
		path: 'wizard', loadChildren: './wizard/wizard.module#WizardModule', canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: true
		}
	},
	{
		path: 'driver-app', loadChildren: './driver-app/driver-app.module#DriverAppModule', canActivate: [AuthGuard],
		data: {
			roles: ['D'],
			is_wizard: false
		}
	},
	{
		path: 'pricelists', loadChildren: './pricelists/pricelists.module#PricelistsModule', canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: false
		}
	},
	{
		path: 'scheduler', loadChildren: './scheduler/scheduler.module#SchedulerModule', canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: false
		}
	},
	{
		path: 'network', loadChildren: './network/network.module#NetworkModule', canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: false
		}
	},
	{
		path: 'customers', loadChildren: './customers/customers.module#CustomersModule', canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: false
		}
	},
	{
		path: 'account', loadChildren: './account/account.module#AccountModule', canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: false
		}
	},

	// standard
	{
		path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard],
		data: {
			roles: ['P'],
			is_wizard: false
		}
	},
	{ path: 'login', component: LoginComponent },
	{ path: 'register', component: RegisterComponent },
	{ path: 'activate/:token', component: ActivateComponent },
	{ path: 'logout', component: LogoutComponent },

	{ path: 'test-scheduler', component: TestSchedulerComponent },

	// default
	{ path: '', redirectTo: '/dashboard', pathMatch: 'full' },

	// wild card route
	{ path: '**', component: PageNotFoundComponent }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
